import { render, staticRenderFns } from "./yAddListItem.vue?vue&type=template&id=c926bc7a"
import script from "./yAddListItem.vue?vue&type=script&lang=js"
export * from "./yAddListItem.vue?vue&type=script&lang=js"
import style0 from "./yAddListItem.vue?vue&type=style&index=0&id=c926bc7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/src/oncheckbuild_FutureGAJDKUpgrade90d6697d/FL2FL3nodefinapp/subbrandtool/client/1.0/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VTextField})
